module.exports = __webpack_public_path__ + "img/image3.0923f4f1.png";